import React, { useEffect } from "react";
import { Tile } from "components/UIComponents/Tile";
import { getClientVerifications, getDocIntelligenceData, getDocument } from "api";
import { DateFormat } from "components/common/formatter";
import { Button } from "@progress/kendo-react-buttons";
import styles from "./index.module.scss";
import { useState } from "react";
import DataList from "components/MatterDetails/DataList";
import { PrimaryBadgeComponent } from "components/UIComponents/Badges";
import ImageIcon from "../../assets/image-icon.png";
import EditIcon from "../../assets/common/editBoxIcon.png";
import Verified from "../../assets/checked 1.png";
import IntelligentDoc from "../../assets/add-doc-intelligence.svg";
import { getFileIcon } from "components/common/DocumentViewer/fileUtils";
import AddEditProof from "./AddEditProof";
import DirectorForm from "./DirectorForm";
import AddOwners from "./AddEditOwner";
import { VerificationProofType, getDocType } from "components/Enums/IDCheck.ts";
import DocumentViewer from "components/common/DocumentViewer";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import { FileDocumentTypes } from "components/Enums/FileDocumentTypes.ts";
import { toast } from "react-toastify";
import DoccIntelligenceModal from "./DocIntelligenceLoaderModal";
import { useCompany } from "services/companyService";
import { TileWrapper } from "components/UIComponents/TileWrapper.jsx";
import { FaPlus, FaRegCalendarAlt } from "react-icons/fa";
import { HiShieldCheck } from "react-icons/hi2";
import { FaCircleCheck, FaPen, FaPassport } from "react-icons/fa6";

const stringPurifier = (data) => (data ? data : "");

export const IdCheck = ({ client }) => {
  const [verificationData, setVerifcationData] = useState({});
  const [editProof, setEditProof] = useState(false);
  const [currentActiveTab, setCurrentActiveTab] = useState("Company");
  const [addNew, setAddNew] = useState(false);
  const [addDirector, setAddDirector] = useState(false);
  const [editDirector, setEditDirector] = useState(null);
  const [addOwner, setAddOwner] = useState(false);
  const [documentViewrData, setDocumentViewerData] = useState([]);
  const [docIntelligentData, setDocIntelligentData] = useState(null);
  const [showPdf, setShowPdf] = useState(false);
  const [proofsData, setProofsData] = useState({});
  const [comboBoxState, setComboBoxState] = useState({ director: null });
  const { data: company } = useCompany();
  const locale = company?.locale;
  const getClientVerificationsData = async (selectId = null) => {
    try {
      const data = await getClientVerifications(client?.clientId);
      const allDirectors = data?.data?.data?.directors || [];
      const activeDirectors = allDirectors
        .filter((d) => d.active !== false)
        .sort((a, b) => b.companyPersonId - a.companyPersonId);
      setProofsData({
        addressProof: data?.data?.data?.addressProof,
        proofOfID: data?.data?.data?.proofOfID,
        companyProof1: data?.data?.data?.companyProof1,
        companyProof2: data?.data?.data?.companyProof2,
        otherProofs: data?.data?.data?.otherProofs || [],
        directors: activeDirectors,
        owner1: data?.data?.data?.owner1 || {},
        owner2: data?.data?.data?.owner2 || {},
        owner3: data?.data?.data?.owner3 || {},
        owner4: data?.data?.data?.owner4 || {},
      });
      if (activeDirectors.length) {
        const target = selectId
          ? (activeDirectors.find((d) => d.companyPersonId === selectId) ??
            activeDirectors[0])
          : activeDirectors[0];
        setComboBoxState({ director: target });
      } else {
        setComboBoxState({ director: null });
      }
      setVerifcationData(data?.data?.data);
    } catch (error) { }
  };

  const showPDFFile = async (id) => {
    try {
      const { data } = await getDocument(id);
      setDocumentViewerData([data.data]);
      setShowPdf(true);
    } catch (error) { }
  };

  useEffect(() => {
    if (client) {
      getClientVerificationsData();
    }
  }, []);

  const getDirectorHeading = (director) => {
    if (!director) return "Summary";
    const fullName = `${director.firstName || ""} ${director.lastName || ""}`.trim();
    return fullName ? `Summary (${fullName})` : "Summary";
  };

  return (
    <TileWrapper>
      {client?.type === "Company" && currentActiveTab === "Beneficial Owner" ? (
        <div className={`d-flex flex-column flex-fill ${styles.directorIdLayout}`}>
          <div className="flex-grow-1 overflow-auto p-1">
            <div className="row g-1 row-cols-2 h-100">
              <div className="col d-flex flex-column " style={{ minHeight: 0 }}>
                <Tile
                  heading={`Beneficial Owner 1`}
                  className=" px-4 py-2 h-100 d-flex flex-column overflow-hidden m-1"
                  headingClass={"px-2"}
                  style={{ minHeight: "200px", flex: 1 }}>
                  <div
                    className="container-fluid overflow-auto flex-grow-1"
                    style={{ minHeight: 0 }}>
                    <OwnerData data={proofsData?.owner1} index={0} />
                  </div>
                </Tile>
              </div>
              <div className="col d-flex flex-column " style={{ minHeight: 0 }}>
                <Tile
                  heading={`Beneficial Owner 2`}
                  headingClass={"px-2"}
                  className=" ps-4 pe-4 h-100 d-flex flex-column overflow-hidden m-1"
                  style={{ minHeight: "200px", flex: 1 }}>
                  <div
                    className="container-fluid overflow-auto flex-grow-1"
                    style={{ minHeight: 0 }}>
                    <OwnerData data={proofsData?.owner2} />
                  </div>
                </Tile>
              </div>
              <div className="col d-flex flex-column" style={{ minHeight: 0 }}>
                <Tile
                  headingClass={"px-2"}
                  heading={`Beneficial Owner 3`}
                  className=" ps-4 pe-4 h-100 d-flex flex-column overflow-hidden m-1"
                  style={{ minHeight: "200px", flex: 1 }}>
                  <div
                    className="container-fluid overflow-auto flex-grow-1"
                    style={{ minHeight: 0 }}>
                    <OwnerData data={proofsData?.owner3} index={0} />
                  </div>
                </Tile>
              </div>
              <div className="col d-flex flex-column" style={{ minHeight: 0 }}>
                <Tile
                  heading={`Beneficial Owner 4`}
                  className=" ps-4 pe-4 h-100 d-flex flex-column overflow-hidden m-1"
                  headingClass={"px-2"}
                  style={{ minHeight: "200px", flex: 1 }}>
                  <div
                    className="container-fluid overflow-auto flex-grow-1"
                    style={{ minHeight: 0 }}>
                    <OwnerData data={proofsData?.owner4} />
                  </div>
                </Tile>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {client?.type === "Company" && currentActiveTab === "Director ID" ? (
            <div className={`d-flex gap-2 ${styles.directorIdLayout}`}>
              <div>
                <Tile
                  heading={`Director Details`}
                  headingClass={"px-2"}
                  className="mb-2 ps-4 pe-4 overflow-auto h-100"
                  width={"300px"}
                  headingItems={
                    <Button
                      className="button-small"
                      onClick={() => setAddDirector(true)}>
                      Add Director
                    </Button>
                  }>
                  <div className="d-flex flex-column gap-2 mb-2">
                    {proofsData?.directors?.length ? (
                      proofsData.directors.map((director, index) => {
                        const isSelected =
                          comboBoxState?.director?.companyPersonId ===
                          director.companyPersonId;
                        return (
                          <div
                            key={director.companyPersonId ?? `director-${index}`}
                            className={`d-flex align-items-start justify-content-between gap-2 rounded p-2 cursor-pointer`}
                            style={{
                              backgroundColor: isSelected ? "#F7F7F8" : "white",
                              border: isSelected
                                ? "2px solid #F7F7F8"
                                : "2px solid #F2F2F6",
                            }}
                            onClick={() => setComboBoxState({ director })}>
                            <div className="flex-grow-1 min-w-0">
                              <div className="fw-bold small mb-2 text-dark text-capitalize">
                                {`${director.firstName || ""} ${director.lastName || ""}`.trim() ||
                                  "-"}
                              </div>
                              <div className="d-flex flex-column gap-1 small text-muted fw-semibold">
                                <div className="d-flex align-items-center gap-1">
                                  <FaRegCalendarAlt
                                    size={12}
                                    style={{ marginBottom: "2px" }}
                                    color="#9e9e9e"
                                    className="flex-shrink-0"
                                  />
                                  Date of Birth:
                                  <span>
                                    {director.dateOfBirth
                                      ? DateFormat(director.dateOfBirth, locale)
                                      : "-"}
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  <FaRegCalendarAlt
                                    size={12}
                                    style={{ marginBottom: "2px" }}
                                    color="#9e9e9e"
                                    className="flex-shrink-0"
                                  />
                                  Director Since:
                                  <span>
                                    {director.dateOfBirth
                                      ? DateFormat(director?.verifiedDate, locale)
                                      : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex flex-column align-items-center gap-2">
                              <div
                                className="flex-shrink-0 d-flex align-items-center justify-content-center bg-white rounded-1"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  border: "1px solid #F2F2F6",
                                }}>
                                {director?.verified ? (
                                  <HiShieldCheck size={18} color="#1FBF55" />
                                ) : (
                                  " "
                                )}
                              </div>
                              <div
                                className="flex-shrink-0 d-flex align-items-center justify-content-center bg-white rounded-1 cursor-pointer"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  border: "1px solid #F2F2F6",
                                }}
                                title="Edit Director"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setEditDirector(director);
                                }}>
                                <FaPen size={11} color="#6c757d" />
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-muted small py-3 text-center">
                        No directors added yet.
                      </div>
                    )}
                  </div>
                </Tile>
              </div>
              <div className="h-100 w-100">
                <Tile
                  heading={getDirectorHeading(comboBoxState?.director)}
                  className="mb-2 ps-4 pe-4"
                  headingClass={"px-2"}
                  style={{ overFlowX: "hidden" }}
                  height={"160px"}>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-2">
                        <DataList
                          text="Passport No:"
                          value={
                            comboBoxState["director"]?.passportDetails?.passportNo
                          }
                          className="d-flex flex-column gap-0"
                          alignItems="flex-start"
                          keyClass="mb-1"
                          keyStyles={{ minWidth: "100px" }}
                          width={"w-100"}
                        />
                      </div>
                      <div className="col-2">
                        <DataList
                          text="Issue On:"
                          statusChart={true}
                          keyStyles={{ minWidth: "80px" }}
                          value={DateFormat(
                            comboBoxState["director"]?.passportDetails
                              ?.passportIssueDate,
                            locale,
                          )}
                          className="d-flex flex-column gap-0"
                          alignItems="flex-start"
                          keyClass="mb-1"
                          width={"w-100"}
                        />
                      </div>
                      <div className="col-2">
                        <DataList
                          text="Expiry:"
                          statusChart={true}
                          keyStyles={{ minWidth: "70px" }}
                          value={DateFormat(
                            comboBoxState["director"]?.passportDetails
                              ?.passportExpiryDate,
                            locale,
                          )}
                          className="d-flex flex-column gap-0"
                          alignItems="flex-start"
                          keyClass="mb-1"
                          width={"w-100"}
                        />
                      </div>
                      <div className="col-3">
                        <DataList
                          text="Country:"
                          keyStyles={{ minWidth: "70px" }}
                          statusChart={true}
                          value={
                            comboBoxState["director"]?.passportDetails
                              ?.passportIssuedBy
                          }
                          className="d-flex flex-column gap-0"
                          alignItems="flex-start"
                          keyClass="mb-1"
                          width={"w-100"}
                        />
                      </div>
                      <div className="col-3">
                        <DataList
                          text="Driving License:"
                          keyStyles={{ minWidth: "110px" }}
                          value={
                            comboBoxState["director"]?.licenseDetails?.licenseNo
                          }
                          className="d-flex flex-column gap-0"
                          alignItems="flex-start"
                          keyClass="mb-1"
                          width={"w-100"}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <DataList
                          text="Address:"
                          value={comboBoxState["director"]?.fullAddressDetails}
                          className="gap-3 justify-content-start"
                          keyStyles={{ minWidth: "10px" }}
                          statusChart={true}
                        />
                      </div>
                    </div>
                  </div>
                </Tile>
                <Tile
                  heading={`Identity Requirements`}
                  className={`mb-2 ps-4 pe-4 overflow-auto w-100 ${styles.requirementsTile}`}
                  headingClass={"px-2"}
                  headingItems={
                    <Button className="button-small" onClick={() => setAddNew(true)}>
                      <FaPlus
                        size={10}
                        className="me-1"
                        style={{ marginBottom: "2px" }}
                      />
                      Add Other Proof
                    </Button>
                  }>
                  <div className="">
                    {client.type === "Company" &&
                      currentActiveTab === "Director ID" && (
                        <>
                          <ProofTileCompany
                            clientId={client?.clientId}
                            setDocIntelligentData={setDocIntelligentData}
                            proofType={VerificationProofType.ProofOfID}
                            onClick={(e) =>
                              setEditProof({
                                ...e,
                                companyPersonId:
                                  comboBoxState["director"]?.companyPersonId,
                                proofType: VerificationProofType.ProofOfID,
                              })
                            }
                            companyPersonId={
                              comboBoxState["director"]?.companyPersonId
                            }
                            showPDFFile={showPDFFile}
                            type="Proof of Id"
                            data={comboBoxState["director"]?.proofs?.proofOfID}
                            directors={comboBoxState["director"] === null}
                          />
                          <ProofTileCompany
                            clientId={client?.clientId}
                            setDocIntelligentData={setDocIntelligentData}
                            proofType={VerificationProofType.AddressProof}
                            companyPersonId={
                              comboBoxState["director"]?.companyPersonId
                            }
                            onClick={(e) =>
                              setEditProof({
                                ...e,
                                companyPersonId:
                                  comboBoxState["director"]?.companyPersonId,
                                proofType: VerificationProofType.AddressProof,
                              })
                            }
                            type="Address Proof"
                            showPDFFile={showPDFFile}
                            data={comboBoxState["director"]?.proofs?.addressProof}
                            directors={comboBoxState["director"] === null}
                          />
                        </>
                      )}
                    {client.type === "Company" &&
                      currentActiveTab === "Director ID" &&
                      comboBoxState["director"]?.proofs?.otherProofs?.map(
                        (proof, index) => (
                          <ProofTileCompany
                            clientId={client?.clientId}
                            setDocIntelligentData={setDocIntelligentData}
                            key={index}
                            showPDFFile={showPDFFile}
                            proofType={VerificationProofType.Other}
                            onClick={(e) =>
                              setEditProof({
                                ...e,
                                companyPersonId:
                                  comboBoxState["director"]?.companyPersonId,
                                proofType: VerificationProofType.Other,
                              })
                            }
                            type={proof.proofTypeName}
                            companyPersonId={
                              comboBoxState["director"]?.companyPersonId
                            }
                            data={proof}
                            directors={comboBoxState["director"] === null}
                          />
                        ),
                      )}
                  </div>
                </Tile>
              </div>
            </div>
          ) : (
            <>
              <div className="row g-2">
                <div className="col-12 col-xl-6">
                  <Tile
                    headingClass={"px-2"}
                    heading={`${client.type === "Company" ? "Company" : "Person"
                      } Details`}
                    className="ps-4 pe-4 overflow-auto"
                    height={"190px"}>
                    {client.type === "Person" && (
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-3">
                            <DataList
                              text="First Name:"
                              // statusChart={true}
                              // className="col-4"
                              value={client?.contact?.person?.firstName}
                              // valueClass="text-danger"
                              keyStyles={{ minWidth: "120px" }}
                              width={"w-100"}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <DataList
                              text="Last Name:"
                              // statusChart={true}
                              // className="col-4"
                              value={client?.contact?.person?.lastName}
                              keyStyles={{ minWidth: "120px" }}
                              width={"w-100"}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <DataList
                              text="Date of Birth:"
                              // statusChart={true}
                              // className="col-4"
                              value={DateFormat(
                                client?.contact?.person?.dateOfBirth,
                                locale,
                              )}
                              // valueClass="text-danger"
                              keyStyles={{ minWidth: "120px" }}
                              width={"w-100"}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {client.type === "Company" && currentActiveTab === "Company" && (
                      <>
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-6">
                              <DataList
                                text="Company Name:"
                                // statusChart={true}
                                keyStyles={{ minWidth: "150px" }}
                                // className="col-4"
                                value={client?.clientName}
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>{" "}
                            <div className="col-6">
                              <DataList
                                text="Registration No:"
                                // statusChart={true}
                                // className="col-4"
                                keyStyles={{ minWidth: "120px" }}
                                value={client?.regNo}
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <DataList
                                text="VAT Reg No:"
                                // statusChart={true}
                                // className="col-4"
                                keyStyles={{ minWidth: "150px" }}
                                value={client?.contact?.company?.vatNo}
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>{" "}
                            <div className="col-6">
                              <DataList
                                text="SIC Code:"
                                // statusChart={true}
                                // className="col-4"
                                keyStyles={{ minWidth: "120px" }}
                                value={client?.contact?.company?.sicCode}
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <DataList
                                text="Registered Address:"
                                keyStyles={{ minWidth: "150px" }}
                                value={`${stringPurifier(
                                  client?.contact?.company?.registeredAddress?.line1,
                                )} ${stringPurifier(
                                  client?.contact?.company?.registeredAddress?.line2,
                                )} ${stringPurifier(
                                  client?.contact?.company?.registeredAddress?.state,
                                )} ${stringPurifier(
                                  client?.contact?.company?.registeredAddress
                                    ?.postCode,
                                )}  ${stringPurifier(
                                  client?.contact?.company?.registeredAddress
                                    ?.country,
                                )}`}
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>{" "}
                          </div>
                        </div>
                      </>
                    )}
                  </Tile>
                </div>

                <div className="col-12 col-xl-6">
                  <Tile
                    heading={`Summary`}
                    className="mb-2 ps-4 pe-4"
                    headingClass={"px-2"}
                    style={{ overFlowX: "hidden" }}
                    height={"190px"}>
                    {client.type === "Person" && (
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-6 p-0 ps-2">
                            <DataList
                              text="Passport No:"
                              value={verificationData?.passportDetails?.passportNo}
                              keyStyles={{ minWidth: "100px" }}
                              valueClass="truncate"
                              width={"w-100"}
                            />
                          </div>

                          <div className="col-3 p-0">
                            <DataList
                              text="Expiry:"
                              statusChart={true}
                              keyStyles={{ minWidth: "50px" }}
                              value={DateFormat(
                                verificationData?.passportDetails
                                  ?.passportExpiryDate,
                                locale,
                              )}
                              width={"w-100"}
                            />
                          </div>
                          <div className="col-3 p-0">
                            <DataList
                              text="Country:"
                              keyStyles={{ minWidth: "70px" }}
                              statusChart={true}
                              value={
                                verificationData?.passportDetails
                                  ?.passportCountryCode
                              }
                              width={"w-100"}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-0 ps-2">
                            <DataList
                              text="Driving License:"
                              keyStyles={{ minWidth: "110px" }}
                              value={verificationData?.licenseDetails?.licenseNumber}
                              width={"w-100"}
                            />
                          </div>
                          <div className="col-3 p-0">
                            <DataList
                              text="Expiry:"
                              statusChart={true}
                              keyStyles={{ minWidth: "50px" }}
                              value={DateFormat(
                                verificationData?.licenseDetails?.licenseExpiryDate,
                                locale,
                              )}
                              width={"w-100"}
                            />
                          </div>
                          <div className="col-3 p-0">
                            <DataList
                              text="Country:"
                              keyStyles={{ minWidth: "70px" }}
                              statusChart={true}
                              value={
                                verificationData?.licenseDetails?.licenseCountryCode
                              }
                              width={"w-100"}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 p-0 ps-2">
                            <DataList
                              text="Address:"
                              value={verificationData?.fullAddressDetails}
                              keyStyles={{ minWidth: "100px" }}
                              width={"w-100"}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {client.type === "Company" && currentActiveTab === "Company" && (
                      <>
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12">
                              <DataList
                                text="Directors:"
                                keyStyles={{ minWidth: "150px" }}
                                value={
                                  <div className="d-flex align-items-center gap-4">
                                    <div className="me-3">
                                      {proofsData?.directors &&
                                        `${stringPurifier(
                                          proofsData.directors[0]?.firstName,
                                        )} ${stringPurifier(
                                          proofsData.directors[0]?.lastName,
                                        )}`}
                                    </div>
                                    <div className="me-3">
                                      {proofsData?.directors &&
                                        `${stringPurifier(
                                          proofsData.directors[1]?.firstName,
                                        )} ${stringPurifier(
                                          proofsData.directors[1]?.lastName,
                                        )}`}{" "}
                                    </div>
                                    <div>
                                      {proofsData?.directors &&
                                        `${stringPurifier(
                                          proofsData.directors[2]?.firstName,
                                        )} ${stringPurifier(
                                          proofsData.directors[2]?.lastName,
                                        )}`}
                                    </div>
                                  </div>
                                }
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>{" "}
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <DataList
                                text="Significant Control:"
                                // statusChart={true}
                                // className="col-4"
                                keyStyles={{ minWidth: "150px" }}
                                value={
                                  proofsData?.directors &&
                                  proofsData?.directors[0]?.significantControl
                                }
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>{" "}
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <DataList
                                text="Company Type"
                                // statusChart={true}
                                // className="col-4"
                                keyStyles={{ minWidth: "120px" }}
                                value={client?.companyType}
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>{" "}
                            <div className="col-6">
                              <DataList
                                text="Status:"
                                // statusChart={true}
                                // className="col-4"
                                keyStyles={{ minWidth: "120px" }}
                                value={client?.status}
                                // valueClass="text-danger"
                                width={"w-100"}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </Tile>
                </div>
              </div>
              <Tile
                heading={`Identity Requirements`}
                className="mb-2 ps-4 pe-4 overflow-auto"
                headingClass={"px-2"}
                height={"330px"}
                headingItems={
                  <Button className="button-small" onClick={() => setAddNew(true)}>
                    <FaPlus
                      size={10}
                      className="me-1"
                      style={{ marginBottom: "2px" }}
                    />
                    Add Other Proof
                  </Button>
                }>
                {client.type === "Company" &&
                  currentActiveTab === "Beneficial Owner" ? (
                  <></>
                ) : (
                  <div className={``}>
                    {client.type === "Person" && (
                      <>
                        <ProofTile
                          clientId={client?.clientId}
                          proofType={VerificationProofType.ProofOfID}
                          onClick={(e) =>
                            setEditProof({
                              ...e,
                              proofType: VerificationProofType.ProofOfID,
                            })
                          }
                          setDocIntelligentData={setDocIntelligentData}
                          type="Proof of Id"
                          showPDFFile={showPDFFile}
                          data={proofsData.proofOfID}
                        />
                        <ProofTile
                          clientId={client?.clientId}
                          setDocIntelligentData={setDocIntelligentData}
                          proofType={VerificationProofType.AddressProof}
                          onClick={(e) =>
                            setEditProof({
                              ...e,
                              proofType: VerificationProofType.AddressProof,
                            })
                          }
                          type="Address Proof"
                          showPDFFile={showPDFFile}
                          data={proofsData.addressProof}
                        />
                      </>
                    )}
                    {client.type === "Company" && currentActiveTab === "Company" && (
                      <>
                        <ProofTile
                          clientId={client?.clientId}
                          setDocIntelligentData={setDocIntelligentData}
                          proofType={VerificationProofType.CompanyProof1}
                          onClick={(e) =>
                            setEditProof({
                              ...e,
                              proofType: VerificationProofType.CompanyProof1,
                            })
                          }
                          type="Company Proof 1"
                          showPDFFile={showPDFFile}
                          data={proofsData.companyProof1}
                        />
                        <ProofTile
                          clientId={client?.clientId}
                          setDocIntelligentData={setDocIntelligentData}
                          proofType={VerificationProofType.CompanyProof2}
                          onClick={(e) =>
                            setEditProof({
                              ...e,
                              proofType: VerificationProofType.CompanyProof2,
                            })
                          }
                          showPDFFile={showPDFFile}
                          type="Company Proof 2"
                          data={proofsData.companyProof2}
                        />
                      </>
                    )}
                    {(client.type === "Person" || currentActiveTab === "Company") &&
                      proofsData?.otherProofs?.map((proof, index) => (
                        <ProofTile
                          key={index}
                          clientId={client?.clientId}
                          showPDFFile={showPDFFile}
                          setDocIntelligentData={setDocIntelligentData}
                          proofType={VerificationProofType.Other}
                          onClick={(e) => {
                            setEditProof({
                              ...e,
                              proofType: VerificationProofType.Other,
                            });
                          }}
                          companyPersonId={
                            comboBoxState["director"]?.companyPersonId
                          }
                          type={"Other"}
                          data={proof}
                        />
                      ))}
                  </div>
                )}
                {currentActiveTab === "Beneficial Owner" && (
                  <>
                    <OwnerData data={proofsData?.owner1} index={0} />
                    <OwnerData data={proofsData?.owner2} />
                    <OwnerData data={proofsData?.owner3} />
                    <OwnerData data={proofsData?.owner4} />
                  </>
                )}
              </Tile>
            </>
          )}
        </>
      )}
      {client.type === "Company" && (
        <div
          className={`${styles["comapany-proof-tabs"]} mt-3 px-4 d-flex align-items-center gap-2`}>
          <Menutem
            tabName="Company"
            active={currentActiveTab}
            onClick={(e) => setCurrentActiveTab(e)}
          />
          <div className={`${styles["horizontal-bar"]}`}></div>
          <Menutem
            tabName="Director ID"
            active={currentActiveTab}
            onClick={(e) => setCurrentActiveTab(e)}
          />
          <div className={`${styles["horizontal-bar"]}`}></div>
          <Menutem
            tabName="Beneficial Owner"
            active={currentActiveTab}
            onClick={(e) => setCurrentActiveTab(e)}
          />
        </div>
      )}
      {(editProof !== false || addNew || docIntelligentData) && (
        <AddEditProof
          cancelEdit={() => {
            setEditProof(false);
            setAddNew(false);
            setDocIntelligentData(null);
          }}
          proof={editProof || docIntelligentData}
          docIntelligentData={docIntelligentData}
          type={
            client?.type === "Person" ||
              (client?.type === "Company" && currentActiveTab === "Director ID")
              ? "Person"
              : "Company"
          }
          addNew={addNew}
          clientId={client?.clientId}
          companyPersonId={
            client?.type === "Company" && currentActiveTab === "Director ID"
              ? comboBoxState["director"]?.companyPersonId
              : undefined
          }
          updateSuccess={() => {
            setEditProof(false);
            setAddNew(false);
            setDocIntelligentData(null);
            getClientVerificationsData();
          }}
        />
      )}
      {(addDirector || editDirector) && (
        <DirectorForm
          cancelEdit={() => {
            setAddDirector(false);
            setEditDirector(null);
          }}
          editData={editDirector}
          clientId={client?.clientId}
          onUpdateData={(e) => {
            getClientVerificationsData(e?.companyPersonId ?? null);
          }}
        />
      )}
      {addOwner && (
        <AddOwners
          cancelEdit={() => {
            setAddOwner(false);
          }}
          clientId={client?.clientId}
          data={{
            owner1: proofsData?.owner1,
            owner2: proofsData?.owner2,
            owner3: proofsData?.owner3,
            owner4: proofsData?.owner4,
          }}
          onUpdateData={() => getClientVerificationsData()}
        />
      )}
      {showPdf && (
        <DocumentViewer
          data={documentViewrData}
          onClose={() => {
            setShowPdf(false);
            setDocumentViewerData([]);
          }}
        />
      )}
    </TileWrapper>
  );
};

export const ProofTile = (props) => {
  const { data: company } = useCompany();
  const isDocumentIntelligenceEnabled = Boolean(
    company?.modules?.DocumentIntelligence,
  );
  const { isSuccess, uploadForm, progress, reset } = useUploadForm();
  const [filesData, setFilesData] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const filePickerRef = React.useRef();
  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);
    const dataChoosen = await uploadForm(data, e.target.files[0], {
      documentType: FileDocumentTypes.ClientDocs,
      clientId: props.clientId,
    });
    data.fileID = dataChoosen.data.data.fileID;
    if (!isDocumentIntelligenceEnabled) {
      setFilesData([]);
      return;
    }
    const dataRecieved = await getDocIntelligenceData(data.fileID);
    const extreactedData = dataRecieved?.data?.data;
    props.setDocIntelligentData({
      documentType: getDocType(extreactedData?.documentType),
      dateOfBirth: extreactedData?.fields?.["DateOfBirth"],
      downloadURL: dataChoosen.data.data?.downloadURL,
      expiryDate: extreactedData?.fields?.["DateOfExpiration"],
      issuedDate: extreactedData?.fields?.["DateOfIssue"],
      documentNumber: extreactedData?.fields?.["DocumentNumber"],
      issuedBy: extreactedData?.fields?.["IssuingAuthority"],
      address:
        extreactedData?.fields?.Address?.streetAddress +
        extreactedData?.fields?.Address?.city +
        extreactedData?.fields?.Address?.countryRegion,
      documentFile: data?.fileID,
      proofType: props.proofType,
      countryCode: extreactedData?.fields?.["CountryRegion"] || "GBR",
      country: extreactedData?.fields?.["PlaceOfBirth"],
      companyPersonId: props?.companyPersonId,
    });
    setFilesData([]);
  };

  const changeHandler = async (e) => {
    try {
      setIsLoading(true);
      await handleUpload(e);
      setIsLoading(false);
      e.target.value = null;
    } catch (error) {
      setIsLoading(false);
    }
  };
  return (
    <div className={`${styles["proof-tile"]} pt-2 pb-2 container-fluid mt-1 px-3`}>
      <div className="row">
        <div
          className="col-2"
          style={{ marginBottom: "-15px", maxWidth: "180px" }}></div>
        <div className="col-3">
          <DataList
            text="Document Type:"
            value={
              props?.data?.documentType ? (
                <span className="d-flex align-items-center gap-1 text-primary">
                  {props.data.documentType.toLowerCase() === "passport" && (
                    <FaPassport size={14} color="#6c757d" />
                  )}
                  {props.data.documentType}
                </span>
              ) : null
            }
            className={` d-flex flex-column flex-xl-row `}
            keyStyles={{ minWidth: "120px", marginBottom: "3px" }}
            alignItems={"flex-start"}
          />
        </div>

        {props?.data?.proofType !== "AddressProof" && (
          <div className="col-3">
            <DataList
              text="Document No:"
              value={props?.data?.documentNumber}
              width={"w-100"}
              keyStyles={{ minWidth: "110px", marginBottom: "3px" }}
              alignItems={"flex-start"}
              className={` d-flex flex-column flex-xl-row m-0`}
            />
          </div>
        )}

        {props?.data?.proofType === "AddressProof" && (
          <div className="col-3">
            <DataList
              text="Address:"
              value={props?.data?.documentData}
              width={"w-100"}
              keyStyles={{ minWidth: "110px", marginBottom: "3px" }}
              alignItems={"flex-start"}
              className={` d-flex flex-column flex-xl-row m-0`}
            />
          </div>
        )}

        <div className="col-1">
          <DataList
            text="Code:"
            value={props?.data?.countryCode}
            valueClass={"text-truncate"}
            width={"w-100"}
            keyStyles={{ minWidth: "50px", marginBottom: "3px" }}
            alignItems={"flex-start"}
            className={` d-flex flex-column flex-xl-row m-0`}
          />
        </div>
        <div className="col-2">
          <DataList
            text="Country:"
            value={props?.data?.country}
            valueClass={"text-truncate"}
            width={"w-100"}
            keyStyles={{ minWidth: "80px", marginBottom: "3px" }}
            alignItems={"flex-start"}
            className={` d-flex flex-column flex-xl-row m-0`}
          />
        </div>
        <div className="col d-flex align-items-center justify-content-end"></div>
      </div>
      <div className="row">
        <div className="col-2" style={{ maxWidth: "180px" }}>
          <PrimaryBadgeComponent
            text={props.type || "Proof of Id"}
            className="text-center me-3"
            style={{ width: "110px" }}
          />
          {props.data?.verified && <img src={Verified}></img>}
        </div>
        <div className="col-8 my-2 my-xl-3">
          <DataList
            text="Details:"
            // statusChart={true}
            // className="col-4"
            value={props.data?.details}
            className={`d-flex flex-column flex-xl-row m-0`}
            // valueClass="text-danger"
            alignItems={"flex-start"}
            width={"w-100"}
            keyStyles={{ minWidth: "120px", marginBottom: "3px" }}
          />
        </div>
        <div
          className="col-2 d-flex align-items-center justify-content-end gap-1 mb-4 mb-xl-0"
          style={{
            marginTop: "-45px",
            // maxWidth: "180px",
          }}>
          {props?.data === null && isDocumentIntelligenceEnabled && (
            <div
              className="d-flex align-items-center justify-content-center cursor-pointer"
              style={{ width: "32px" }}>
              <img
                className="text-center cursor-pointer"
                src={IntelligentDoc}
                style={{ width: "32px", height: "32px", objectFit: "contain" }}
                role="button"
                onClick={() => filePickerRef?.current?.click()}
                alt="Doc Int Icon"></img>
            </div>
          )}
          {props?.data && props.data?.documentId && (
            <div
              className="d-flex align-items-center justify-content-center cursor-pointer mb-2"
              style={{ width: "32px" }}
              onClick={() => props.showPDFFile(props?.data?.documentId)}>
              <img
                src={ImageIcon}
                style={{ width: "26px", height: "26px", objectFit: "contain" }}
                alt="View document"></img>
            </div>
          )}
          {!props.directors && (
            <div className={`d-flex align-items-center cursor-pointer`}>
              <img
                className="cursor-pointer mb-2"
                style={{ width: "20px", height: "20px", objectFit: "contain" }}
                onClick={async () => {
                  if (props.data?.documentId) {
                    const { data } = await getDocument(props.data?.documentId);

                    props.onClick({
                      ...props.data,
                      downloadURL: data?.data?.documentFile?.downloadURL,
                    });
                    return;
                  }
                  props.onClick(props.data);
                }}
                src={EditIcon}
                alt="Edit Icon"></img>
            </div>
          )}
          <input
            name="file"
            type="file"
            onChange={changeHandler}
            ref={filePickerRef}
            style={{ visibility: "hidden" }}
          />
        </div>
      </div>
      <hr className="mb-0 mt-1" />
      {isLoading && isDocumentIntelligenceEnabled && <DoccIntelligenceModal />}
    </div>
  );
};

const ProofTileCompany = (props) => {
  const { data: company } = useCompany();
  const isDocumentIntelligenceEnabled = Boolean(
    company?.modules?.DocumentIntelligence,
  );
  const { isSuccess, uploadForm, progress, reset } = useUploadForm();
  const [filesData, setFilesData] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const filePickerRef = React.useRef();
  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);
    const dataChoosen = await uploadForm(data, e.target.files[0], {
      documentType: FileDocumentTypes.ClientDocs,
      clientId: props.clientId,
    });
    data.fileID = dataChoosen.data.data.fileID;
    if (!isDocumentIntelligenceEnabled) {
      setFilesData([]);
      return;
    }
    const dataRecieved = await getDocIntelligenceData(data.fileID);
    const extreactedData = dataRecieved?.data?.data;
    props.setDocIntelligentData({
      documentType: getDocType(extreactedData?.documentType),
      dateOfBirth: extreactedData?.fields?.["DateOfBirth"],
      downloadURL: dataChoosen.data.data?.downloadURL,
      expiryDate: extreactedData?.fields?.["DateOfExpiration"],
      issuedDate: extreactedData?.fields?.["DateOfIssue"],
      documentNumber: extreactedData?.fields?.["DocumentNumber"],
      issuedBy: extreactedData?.fields?.["IssuingAuthority"],
      address:
        extreactedData?.fields?.Address?.streetAddress +
        extreactedData?.fields?.Address?.city +
        extreactedData?.fields?.Address?.countryRegion,
      documentFile: data?.fileID,
      proofType: props.proofType,
      countryCode: extreactedData?.fields?.["CountryRegion"] || "GBR",
      country: extreactedData?.fields?.["PlaceOfBirth"],
      companyPersonId: props?.companyPersonId,
    });
    setFilesData([]);
  };

  const changeHandler = async (e) => {
    try {
      setIsLoading(true);
      await handleUpload(e);
      setIsLoading(false);
      e.target.value = null;
    } catch (error) {
      setIsLoading(false);
    }
  };
  return (
    <div
      className={`d-flex flex-column rounded-3 my-2`}
      style={{ border: "0.5px solid #E6E6E6" }}>
      <div
        className={`${styles["identity-req-title"]} d-flex gap-3 align-items-center ps-4 rounded-top  rounded-top-3`}>
        {props.data?.verified && <FaCircleCheck color="#1FBF55" size={16} />}
        <span className="fw-semibold">{props.type || "Proof of Id"}</span>
      </div>
      <div className="d-flex p-3 px-4">
        <div className="d-flex flex-column w-75">
          <div className="d-flex gap-3 flex-wrap flex-xl-nowrap">
            <DataList
              text="Document Type:"
              value={props?.data?.documentType}
              className={` d-flex flex-column`}
              keyStyles={{ minWidth: "120px", marginBottom: "3px" }}
              alignItems={"flex-start"}
            />
            <DataList
              text="Document No:"
              value={props?.data?.documentNumber}
              width={"w-100"}
              keyStyles={{ minWidth: "110px", marginBottom: "3px" }}
              alignItems={"flex-start"}
              className={`d-flex flex-column`}
            />
            <DataList
              text="Code:"
              value={props?.data?.countryCode}
              valueClass={"text-truncate"}
              width={"w-100"}
              keyStyles={{ minWidth: "30px", marginBottom: "3px" }}
              alignItems={"flex-start"}
              className={`d-flex flex-column`}
            />
            <DataList
              text="Country:"
              value={props?.data?.country}
              valueClass={"text-truncate"}
              width={"w-100"}
              keyStyles={{ minWidth: "80px", marginBottom: "3px" }}
              alignItems={"flex-start"}
              className={`d-flex flex-column`}
            />
          </div>
          <DataList
            text="Details:"
            statusChart={true}
            value={props.data?.details}
            className="gap-3"
            alignItems="flex-start"
            keyStyles={{ minWidth: "50px" }}
          />
        </div>

        <div className="d-flex gap-1 align-items-center justify-content-end w-25">
          {props?.data === null && isDocumentIntelligenceEnabled && (
            <div className="d-flex align-items-center cursor-pointer">
              <img
                className="text-center cursor-pointer"
                src={IntelligentDoc}
                style={{ width: "32px", height: "32px", objectFit: "contain" }}
                role="button"
                onClick={() => filePickerRef?.current?.click()}
                alt="Doc Int Icon"></img>
            </div>
          )}
          {props?.data && props.data?.documentId && (
            <div
              className="gap-2 d-flex align-items-center cursor-pointer rounded-2 p-2 px-2"
              style={{ border: "0.5px solid #E6E6E6", height: "30px" }}
              onClick={() => props.showPDFFile(props?.data?.documentId)}>
              <img
                src={getFileIcon("document.pdf")}
                alt="Document"
                style={{ width: 20, height: 20, objectFit: "contain" }}
              />
              {"document.pdf"}
            </div>
          )}
          {!props.directors && (
            <div
              className="cursor-pointer d-flex align-items-center justify-content-center mb-2"
              onClick={async () => {
                if (props.data?.documentId) {
                  const { data } = await getDocument(props.data?.documentId);

                  props.onClick({
                    ...props.data,
                    downloadURL: data?.data?.documentFile?.downloadURL,
                  });
                  return;
                }
                props.onClick(props.data);
              }}>
              <img
                style={{ width: "20px", height: "20px", objectFit: "contain" }}
                src={EditIcon}
                alt="Edit Icon"></img>
            </div>
          )}
          <input
            name="file"
            type="file"
            onChange={changeHandler}
            ref={filePickerRef}
            style={{ visibility: "hidden" }}
          />
        </div>
      </div>

      {isLoading && isDocumentIntelligenceEnabled && <DoccIntelligenceModal />}
    </div>
  );
};

const Menutem = (props) => {
  return (
    <div
      className={`cursor-pointer ms-3 ${props.active === props.tabName
        ? styles["active-tab"]
        : styles["in-active-tab"]
        }`}
      onClick={(e) => props.onClick(props.tabName)}>
      {props.tabName}
    </div>
  );
};

export const OwnerData = (props) => {
  return (
    <div className={`pb-1`}>
      {/* <div className="row"> */}
      <div className="row">
        <DataList
          text="First Name:"
          value={props?.data?.firstName}
          width={"w-100"}
          keyStyles={{ minWidth: "140px" }}
        />
      </div>
      <div className="row">
        <DataList
          text="Last Name:"
          value={props?.data?.lastName}
          width={"w-100"}
          keyStyles={{ minWidth: "140px" }}
        />
      </div>
      <div className="row">
        <DataList
          text="Date of Birth:"
          value={DateFormat(props.data?.dateOfBirth, props.locale)}
          width={"w-100"}
          keyStyles={{ minWidth: "140px" }}
        />
        {/* </div> */}
      </div>
      {/* <div className="row"> */}
      <div className="row">
        <DataList
          text="Percentage Held:"
          value={
            props?.data?.heldPercentage ? `${props?.data?.heldPercentage}%` : ""
          }
          width={"w-100"}
          keyStyles={{ minWidth: "140px" }}
        />
        {/* </div> */}
      </div>
      {/* <hr></hr> */}
    </div>
  );
};
